
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spine",
      function () {
        return require("private-next-pages/spine.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spine"])
      });
    }
  